import { isDesktopMode, getElectronAPI } from "@/plugins/desktop";

export default {
  data() {
    return {
      pagamentos: []
    };
  },
  methods: {
    async getPagamentos() {
      if (isDesktopMode()) {
        const api = getElectronAPI();
        const formas = await api.formasPagamento.listar();
        this.pagamentos = formas ?? [];
        return;
      }
      const { data } = await this.$http.post("/financeiro/formas-pagamento");
      this.pagamentos = data;
    },
  },
};
